import React from "react";
import { Route, Routes, Navigate, useMatch } from "react-router-dom";
import { useSelector } from "react-redux";
import RequireAuth from "components/RequireAuth";

import PageContainer from "../../common/PageContainer";
import ScrollToTopOnMount from "../../../ScrollToTop";

import Search from "./Search";
import AddToExchange from "./AddToExchange";
import TemplateMap from "./TemplateMap";

import { TRANSPORT, TRANSPORT_RELATIVE_ROUTES } from "helpers/routes";

function Transport(props) {
    const authenticated = useSelector((state) => state.auth.authenticated);
    const isMapPage = useMatch('/transport/map/:templateId');

    // Render fullscreen map page without PageContainer
    if (isMapPage) {
        return <TemplateMap templateId={isMapPage.params.templateId} />;
    }

    return (
        <>
            <ScrollToTopOnMount />
            <PageContainer>
                <Routes>
                    <Route index element={<Navigate to={TRANSPORT.search} replace />} />
                    <Route
                        path={TRANSPORT_RELATIVE_ROUTES.search}
                        element={<Search authenticated={authenticated} />}
                    />
                    <Route
                        path={TRANSPORT_RELATIVE_ROUTES.addToExchange}
                        element={<RequireAuth><AddToExchange /></RequireAuth>}
                    />
                    <Route
                        path={TRANSPORT_RELATIVE_ROUTES.edit}
                        element={<RequireAuth><AddToExchange /></RequireAuth>}
                    />
                </Routes>
            </PageContainer>
        </>
    );
}

export default Transport;
